import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import { defaultSiteChromeSettings, normalizeSiteChromeSettings } from "../utils/siteChrome";

const API = "";

function TopbarFooterSetting() {
  const [form, setForm] = useState(defaultSiteChromeSettings);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    axios
      .get(`${API}/api/site-chrome-settings`)
      .then((response) => {
        if (!active) return;
        setForm(normalizeSiteChromeSettings(response.data));
      })
      .catch(() => {
        if (!active) return;
        setForm(defaultSiteChromeSettings);
      });

    return () => {
      active = false;
    };
  }, []);

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const saveSettings = async () => {
    try {
      setSaving(true);
      setMessage("");
      setError("");
      await axios.post(`${API}/api/site-chrome-settings`, form);
      setMessage("Topbar and footer settings saved successfully");
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Topbar and footer settings save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="container-fluid" style={{ display: "grid", gap: "22px" }}>
        <div>
          <h3 style={{ marginBottom: "6px" }}>Topbar & Footer Setting</h3>
          <p className="text-muted mb-0">
            Public front-end er topbar and footer section er somosto visible data ekhane theke edit korte parben.
          </p>
        </div>

        {message ? <div className="alert alert-success mb-0">{message}</div> : null}
        {error ? <div className="alert alert-danger mb-0">{error}</div> : null}

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h5 className="mb-3">Topbar Setting</h5>
            <div className="row g-3">
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Phone</label>
                <input className="form-control" value={form.topbar_phone} onChange={(event) => setField("topbar_phone", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Email</label>
                <input className="form-control" value={form.topbar_email} onChange={(event) => setField("topbar_email", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Button Text</label>
                <input className="form-control" value={form.topbar_button_text} onChange={(event) => setField("topbar_button_text", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Button Link</label>
                <input className="form-control" value={form.topbar_button_link} onChange={(event) => setField("topbar_button_link", event.target.value)} />
              </div>
              <div className="col-lg-8">
                <label className="form-label fw-semibold">Notice Text</label>
                <input className="form-control" value={form.topbar_notice} onChange={(event) => setField("topbar_notice", event.target.value)} />
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h5 className="mb-3">Footer Setting</h5>
            <div className="row g-3">
              <div className="col-lg-3">
                <label className="form-label fw-semibold">Brand Text</label>
                <input className="form-control" value={form.footer_eyebrow} onChange={(event) => setField("footer_eyebrow", event.target.value)} />
              </div>
              <div className="col-lg-9">
                <label className="form-label fw-semibold">Heading</label>
                <input className="form-control" value={form.footer_heading} onChange={(event) => setField("footer_heading", event.target.value)} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">Description</label>
                <textarea className="form-control" rows="4" value={form.footer_description} onChange={(event) => setField("footer_description", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Address</label>
                <input className="form-control" value={form.footer_address} onChange={(event) => setField("footer_address", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Phone</label>
                <input className="form-control" value={form.footer_phone} onChange={(event) => setField("footer_phone", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Email</label>
                <input className="form-control" value={form.footer_email} onChange={(event) => setField("footer_email", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Facebook URL</label>
                <input className="form-control" value={form.facebook_url} onChange={(event) => setField("facebook_url", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">WhatsApp URL</label>
                <input className="form-control" value={form.whatsapp_url} onChange={(event) => setField("whatsapp_url", event.target.value)} />
              </div>
              <div className="col-lg-4">
                <label className="form-label fw-semibold">Instagram URL</label>
                <input className="form-control" value={form.instagram_url} onChange={(event) => setField("instagram_url", event.target.value)} />
              </div>
              <div className="col-lg-6">
                <label className="form-label fw-semibold">LinkedIn URL</label>
                <input className="form-control" value={form.linkedin_url} onChange={(event) => setField("linkedin_url", event.target.value)} />
              </div>
              <div className="col-lg-6">
                <label className="form-label fw-semibold">Twitter URL</label>
                <input className="form-control" value={form.twitter_url} onChange={(event) => setField("twitter_url", event.target.value)} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">Copyright Text</label>
                <input className="form-control" value={form.footer_copyright} onChange={(event) => setField("footer_copyright", event.target.value)} />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button type="button" className="btn btn-primary px-4" onClick={saveSettings} disabled={saving}>
            {saving ? "Saving..." : "Save Topbar & Footer Setting"}
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default TopbarFooterSetting;
